import { Modal } from "@material-ui/core";
import axios from "axios";
import { useEffect, useState, useCallback, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../App.css";
import Loginpopup from "../../Navbar/Loginmodal";
import Googleplay from "./image/Googleplay.png";
import Applestore from "./image/appdownloads.png";
import './../../Footer/Footer.css';
import FloatingLabelInput from "./BookingForm/FloatingLabelInput";
import FloatingLabelSelect from "./BookingForm/FloatingLabelSelect";
import './BookingForm/PartyForm.css';
import './BookingForm/Feed.css'
import './BookingForm/FloatingLabelInput.css';
import './BookingForm/FloatingLabelSelect.css';
import iziToast from "izitoast";
import Loader from "../../Loader/Loader";
import usePersistentForm, { usePersistentJsonState, usePersistentState } from "./usePersistentForm";

// Constants
const API_ENDPOINTS = {
    PACKAGE_TITLES: "https://partywitty.com/master/Api/getDataPost/AllPackageTitle",
    VENUE_TYPES: "https://partywitty.com/master/APIs/ClubPackage/getVenuType",
    AREA_LEAD: "https://partywitty.com/master/Api/getDataPost/AreaLead",
    GET_AREA_LEAD: "https://partywitty.com/master/Api/getData/getAreaLead",
    COUNTRY_WISE_STATE: "https://partywitty.com/master/Api/getDataPost/countryWiseState",
    STATE_WISE_CITY: "https://partywitty.com/master/Api/getDataPost/stateWiseCity",
    SUBMIT_ENQUIRY: "https://partywitty.com/master/APIs/ClubPackage/submitEnquiry"
};

const MIN_PAX = 10;
const ALLOWED_STATE_IDS = ["4007", "4021", "4022"];
const ALLOWED_CITY_IDS = [
    "134404", "134007", "133234", "131821", "58171",
    "132032", "131853", "133230", "132005", "131953"
];

const ALCOHOLIC_OPTIONS = [
    { id: 1, name: "Alcoholic" },
    { id: 2, name: "Non-Alcoholic" }
];

function PackageLaedFormComp({ clubId, selectedLead }) {
    // State for package data
    const [alcoPacks, setAlcoPacks] = useState([]);
    const [nonAlcoPacks, setNonAlcoPacks] = useState([]);
    const [packagetitlelist, setPackagetitlelist] = useState([]);

    // User and authentication state
    const [userdata, setUserData] = useState(() => {
        const userData = localStorage.getItem("userData");
        return userData ? JSON.parse(userData) : null;
    });
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [doSubmit, setDoSubmit] = useState(false);

    // Location and area state
    const [apiData, setApiData] = useState([]);
    const [citydata, setCityData] = useState([]);
    const [leadarea, setLeadarea] = useState([]);
    const [selectedArea, setSelectedArea] = usePersistentJsonState("selectedAreaData", null);
    const [selectedAreaid, setSelectedAreaid] = usePersistentState("selectedAreaIdData", null);
    const [location12, setLocation12] = usePersistentState("selectedCityData", "");
    const [cityId, setCityId] = usePersistentState("cityIdData", "");


    // Form state
    const [selectedVenu, setSelectedVenu] = useState([]);
    const [packagetitle, setPackagetitle] = usePersistentState("packageTypeData", "");
    const [packtitle, setPacktitle] = usePersistentState("packageTitleData", "");

    // UI state
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [isReserved, setReserved] = useState(false);
    const [cancel, setCancel] = useState(false);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const status = searchParams.get("status");

    // Persistent form data
    const [formData, setFormData] = usePersistentForm("PackageFormData", {
        club_id: clubId || "",
        whatsapp: userdata?.whatsapp || "",
        whatsapp_msg: "true",
        city_id: "",
        area_id: "",
        male: "0",
        female: "0",
        kids: "0",
        party_date: "",
        party_time: "",
        lead_source: "website",
        user_id: userdata?.id || "",
        venue_type: '',
        requirement: "package",
        my_choice: "",
        type: "",
        name: "",
        email: "",
        mobile: "",
        occation: "",
        kids_friendly: "yes",
        latitude: "",
        longitude: "",
        range: "10km",
        instructions: "",
        agree: false
    });


    // Memoized venue type IDs
    const venueTypeIds = useMemo(() => {
        return selectedVenu.map(venue => venue.id).join(",");
    }, [selectedVenu]);

    // Utility functions
    const getPackTitles = useCallback(async (type) => {
        if (!type) return [];

        const formData = new FormData();
        formData.append("type", type);

        try {
            const response = await axios.post(API_ENDPOINTS.PACKAGE_TITLES, formData);
            return response?.data?.data || [];
        } catch (error) {
            console.error("Error fetching package titles:", error);
            return [];
        }
    }, []);

    const getPackType = useCallback((title) => {
        if (alcoPacks.some(pack => pack.name === title)) {
            return "Alcoholic";
        }
        if (nonAlcoPacks.some(pack => pack.name === title)) {
            return "Non-Alcoholic";
        }
        return undefined;
    }, [alcoPacks, nonAlcoPacks]);

    const showToast = useCallback((type, message) => {
        iziToast[type]({
            title: type === 'error' ? 'Error' : 'Success',
            message,
            position: 'topRight',
            timeout: 3000,
        });
    }, []);

    // Initialize package data
    useEffect(() => {
        const loadPackages = async () => {
            const [aPacks, naPacks] = await Promise.all([
                getPackTitles("Alcoholic"),
                getPackTitles("Non-Alcoholic")
            ]);

            setAlcoPacks(aPacks);
            setNonAlcoPacks(naPacks);
        };

        loadPackages();
    }, [getPackTitles]);

    // Handle status from URL params
    useEffect(() => {
        if (status === "success" && !isReserved) {
            setReserved(true);
        }
        if (status === "failed" && !cancel) {
            setCancel(true);
        }
    }, [status, isReserved, cancel]);

    // Update form data when dependencies change
    useEffect(() => {
        const updates = {
            city_id: cityId,
            area_id: selectedArea?.id || "",
            user_id: userdata?.id || "",
            venue_type: venueTypeIds,
            whatsapp: userdata?.whatsapp || "",
            latitude: selectedArea?.latitude || "",
            longitude: selectedArea?.longitude || "",
        };

        // Pre-populate from selectedLead if available
        if (selectedLead) {
            if (selectedLead.party_date) updates.party_date = selectedLead.party_date;
            if (selectedLead.party_time) updates.party_time = selectedLead.party_time;
            if (selectedLead.male) updates.male = selectedLead.male || "0";
            if (selectedLead.female) updates.female = selectedLead.female || "0";
            if (selectedLead.kids) updates.kids = selectedLead.kids || "0";
        }

        setFormData(prevState => ({ ...prevState, ...updates }));

        // Set package type from selectedLead
        const packageType = getPackType(selectedLead?.title);
        if (packageType && packageType !== packagetitle) {
            setPackagetitle(packageType);
            setFormData(prevData => ({ ...prevData, type: packageType }));
        }
    }, [cityId, selectedVenu, selectedLead, selectedArea, userdata, venueTypeIds, getPackType, packagetitle, setFormData, setPackagetitle]);

    // Handle selectedLead city matching
    useEffect(() => {
        if (!selectedLead || !apiData.length) return;

        const matchedCity = apiData.find(
            city => city.name.toLowerCase() === selectedLead.city?.toLowerCase()
        );

        if (matchedCity && matchedCity.id !== cityId) {
            setCityId(matchedCity.id);
            setLocation12(matchedCity.name);
        }
    }, [selectedLead, apiData, cityId, setCityId, setLocation12]);

    // Handle selectedLead area matching
    useEffect(() => {
        if (!selectedLead || !leadarea.length) return;

        const matchedArea = leadarea.find(
            area => area.name.toLowerCase() === selectedLead.area?.toLowerCase()
        );

        if (matchedArea && (!selectedArea || selectedArea.id !== matchedArea.id)) {
            setSelectedArea(matchedArea);
            setSelectedAreaid(matchedArea.id);
        }
    }, [selectedLead, leadarea, selectedArea, setSelectedArea, setSelectedAreaid]);

    // Update form when selectedArea changes
    useEffect(() => {
        if (selectedArea) {
            setFormData(prev => ({
                ...prev,
                area_id: selectedArea.id,
                latitude: selectedArea.latitude,
                longitude: selectedArea.longitude,
            }));
        }
    }, [selectedArea, setFormData]);

    // Load package titles when package type changes
    useEffect(() => {
        if (!packagetitle) return;

        const formData = new FormData();
        formData.append("type", packagetitle);

        axios.post(API_ENDPOINTS.PACKAGE_TITLES, formData)
            .then(response => {
                const packages = response.data.data || [];
                setPackagetitlelist(packages);

                setFormData(prevData => ({
                    ...prevData,
                    type: packagetitle,
                }));

                // Set selected package if it matches selectedLead.title
                if (selectedLead?.title) {
                    const matched = packages.find(item => item.name === selectedLead.title);
                    if (matched) {
                        setPacktitle(matched.id);
                        setFormData(prevData => ({
                            ...prevData,
                            my_choice: matched.name,
                        }));
                    }
                }
            })
            .catch(error => {
                console.error("Error fetching package titles:", error);
            });
    }, [packagetitle, selectedLead, setFormData, setPacktitle]);

    // Load venue types
    useEffect(() => {
        axios.get(API_ENDPOINTS.VENUE_TYPES)
            .then(response => {
                setSelectedVenu(response.data.data || []);
            })
            .catch(error => {
                console.error("Error fetching venue types:", error);
            });
    }, []);

    // Load areas based on city
    useEffect(() => {
        if (!cityId) return;

        const formData = new FormData();
        formData.append("city_id", cityId);

        axios.post(API_ENDPOINTS.AREA_LEAD, formData)
            .then(response => {
                setLeadarea(response.data.data || []);
            })
            .catch(error => {
                console.error("Error fetching areas:", error);
            });
    }, [cityId]);

    // Load city data
    useEffect(() => {
        axios.get(API_ENDPOINTS.GET_AREA_LEAD)
            .then(response => {
                setCityData(response.data.data || []);
            })
            .catch(error => {
                console.error("Error fetching city data:", error);
            });
    }, []);

    // Load filtered cities from states
    useEffect(() => {
        const formData = new FormData();
        formData.append("country_id", "101");

        axios.post(API_ENDPOINTS.COUNTRY_WISE_STATE, formData)
            .then(response => {
                const filteredStates = response.data.data.filter(
                    item => ALLOWED_STATE_IDS.includes(item.id)
                );
                const stateIds = filteredStates.map(item => item.id);

                const cityPromises = stateIds.map(stateId => {
                    const formData = new FormData();
                    formData.append("state_id", stateId);
                    return axios.post(API_ENDPOINTS.STATE_WISE_CITY, formData);
                });

                return Promise.all(cityPromises);
            })
            .then(responses => {
                const combinedData = responses.flatMap(response => response.data.data || []);
                const filteredData = combinedData.filter(item =>
                    ALLOWED_CITY_IDS.includes(item.id)
                );
                setApiData(filteredData);
            })
            .catch(error => {
                console.error("Error fetching city data:", error);
            });
    }, []);

    // Validate form and update button state
    useEffect(() => {
        const {
            party_date,
            party_time,
            male,
            female,
            kids,
            city_id,
        } = formData;

        const maleCount = parseInt(male || "0", 10);
        const femaleCount = parseInt(female || "0", 10);
        const kidsCount = parseInt(kids || "0", 10);
        const totalAdults = maleCount + femaleCount;
        const agreeCheckbox = document.getElementById('agreeCheckbox');

        const isValid = party_date &&
            party_time &&
            selectedArea?.id &&
            city_id &&
            male !== "" && maleCount >= 0 &&
            female !== "" && femaleCount >= 0 &&
            kids !== "" && kidsCount >= 0 &&
            // totalAdults >= MIN_PAX &&
            packagetitle &&
            packtitle &&
            agreeCheckbox?.checked;

        setButtonDisabled(!isValid);
    }, [formData, selectedArea, packagetitle, packtitle]);

    // Handle post-login form submission
    useEffect(() => {
        if (doSubmit && userdata?.id) {
            handleSubmit();
            setDoSubmit(false);
        }
    }, [doSubmit, userdata]);

    // Event handlers
    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    }, [setFormData]);

    const handleNumberInput = useCallback((e) => {
        const { name, value } = e.target;

        if (value < 0) {
            showToast('error', 'Negative values are not allowed');
            return;
        }

        handleInputChange(e);
    }, [handleInputChange, showToast]);

    const handleDateChange = useCallback((e) => {
        const selected = e.target.value;
        const today = new Date().toISOString().split("T")[0];

        if (selected < today) {
            showToast('error', 'Past dates are not allowed');
            return;
        }

        setFormData(prev => ({
            ...prev,
            party_date: selected,
        }));
    }, [setFormData, showToast]);

    const handleTimeSelection = useCallback((e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    }, [setFormData]);

    const handleLocationChange = useCallback((e) => {
        const selectedName = e.target.value;
        setLocation12(selectedName);

        const matchedCity = apiData.find(city => city.name === selectedName);
        if (matchedCity) {
            setCityId(matchedCity.id);
        }
    }, [apiData, setLocation12, setCityId]);

    const handleAreaChange = useCallback((e) => {
        const areaId = e.target.value;
        const matchedArea = leadarea.find(area => area.id === areaId);

        if (matchedArea) {
            setSelectedArea(matchedArea);
            setSelectedAreaid(matchedArea.id);
        }
    }, [leadarea, setSelectedArea, setSelectedAreaid]);

    const handlePackageChange = useCallback((e) => {
        const selectedPackage = e.target.value;
        setPackagetitle(selectedPackage);

        if (selectedPackage) {
            const formData = new FormData();
            formData.append("type", selectedPackage);

            axios.post(API_ENDPOINTS.PACKAGE_TITLES, formData)
                .then(response => {
                    setPackagetitlelist(response.data.data || []);
                    setFormData(prevData => ({
                        ...prevData,
                        type: selectedPackage,
                    }));
                })
                .catch(error => {
                    console.error("Error fetching package titles:", error);
                });
        }
    }, [setPackagetitle, setFormData]);

    const handlePackagename = useCallback((e) => {
        const selectedPackTitle = e.target.value;
        setPacktitle(selectedPackTitle);

        const selectedPackage = packagetitlelist.find(pkg => pkg.id === selectedPackTitle);
        setFormData(prevData => ({
            ...prevData,
            my_choice: selectedPackage?.name || selectedPackTitle,
        }));
    }, [packagetitlelist, setPacktitle, setFormData]);

    const validateForm = useCallback(() => {
        const validations = [
            { condition: !formData.party_date, message: 'Please select a party date' },
            { condition: !formData.party_time, message: 'Please select a party time' },
            { condition: formData.male === "" || formData.male < 0, message: 'Enter a valid number of male guests' },
            { condition: formData.female === "" || formData.female < 0, message: 'Enter a valid number of female guests' },
            { condition: formData.kids === "" || formData.kids < 0, message: 'Enter a valid number of kids' },
            { condition: !formData.city_id, message: 'Please select a city' },
            { condition: !selectedArea?.id, message: 'Please select an area' },
            { condition: !packagetitle, message: 'Please select a package type' },
            { condition: !packtitle, message: 'Please select a package name' },
            { condition: !document.getElementById('agreeCheckbox')?.checked, message: 'You must accept our terms and conditions' },
        ];

        for (const validation of validations) {
            if (validation.condition) {
                showToast('error', validation.message);
                return false;
            }
        }

        const pax = parseInt(formData.male || '0') + parseInt(formData.female || '0');
        if (pax < MIN_PAX) {
            showToast('error', `A minimum of ${MIN_PAX} adult guests are required for booking.`);
            return false;
        }

        return true;
    }, [formData, selectedArea, packagetitle, packtitle, showToast]);

    const handleSubmit = useCallback(async (e) => {
        e?.preventDefault();

        if (!validateForm()) return;

        if (!userdata) {
            setShowLoginPopup(true);
            return;
        }

        const formDataObj = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            formDataObj.append(key, value);
        });

        setLoading(true);

        try {
            const response = await axios.post(API_ENDPOINTS.SUBMIT_ENQUIRY, formDataObj);

            if (response.data.status === true) {
                showToast('success', 'Form submitted successfully');
                // setShowPopup(true);
                document.getElementById('agreeCheckbox').checked = false;

                // Clear form data after successful submission
                setFormData({
                    ...formData,
                    party_date: "",
                    party_time: "",
                    city_id: "",
                    area_id: "",
                    male: "0",
                    female: "0",
                    kids: "0",
                    instructions: "",
                    my_choice: "",
                    type: "",
                    agree: false
                });

                localStorage.removeItem('PackageFormData');
                localStorage.removeItem('selectedAreaData');
                localStorage.removeItem('selectedAreaIdData');
                localStorage.removeItem('selectedCityData');
                localStorage.removeItem('cityIdData');
                localStorage.removeItem('packageTypeData');
                localStorage.removeItem('packageTitleData');

                setTimeout(() => {
                    window.location.href = '/package-lead-submitted';
                }, 1500);
            } else {
                showToast('error', response.data.msg || 'Submission failed');
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            showToast('error', 'An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    }, [validateForm, userdata, formData, setFormData, showToast]);

    const handleLogin = useCallback((ud) => {
        if (ud) {
            setFormData(prevState => ({
                ...prevState,
                user_id: ud.id,
                whatsapp: ud.whatsapp,
            }));
            setUserData(ud);
            localStorage.setItem("userData", JSON.stringify(ud));
            setShowLoginPopup(false);
            setDoSubmit(true);
        }
    }, [setFormData]);

    const handleModalClose = useCallback(() => {
        setShowPopup(false);
        window.location.href = '/';
    }, []);

    return (
        <>
            {loading && <Loader />}
            {showLoginPopup && <Loginpopup clbk={handleLogin} />}

            <div className="pplf-form-container">
                <form onSubmit={handleSubmit} className="party-form">
                    <FloatingLabelInput
                        type="date"
                        name="party_date"
                        label="Party Date"
                        value={formData.party_date}
                        onChange={handleDateChange}
                        min={new Date().toISOString().split("T")[0]}
                    />

                    <FloatingLabelInput
                        type="time"
                        name="party_time"
                        label="Party Time"
                        value={formData.party_time}
                        onChange={handleTimeSelection}
                    />

                    <div className="guest-group">
                        <div className="guest-g-input">
                            <FloatingLabelInput
                                type="number"
                                name="male"
                                label="Male Guests"
                                value={formData.male}
                                onChange={handleNumberInput}
                                min="0"
                                defaultValue={0}
                            />
                            {/* <span className="small-text-form">21 years and above</span> */}
                        </div>

                        <div className="guest-g-input">
                            <FloatingLabelInput
                                type="number"
                                name="female"
                                value={formData.female}
                                label="Female Guests"
                                onChange={handleNumberInput}
                                defaultValue={0}
                                min="0"
                            />
                            {/* <span className="small-text-form">21 years and above</span> */}
                        </div>
                    </div>

                    <div>
                        <FloatingLabelInput
                            type="number"
                            name="kids"
                            label="Kids"
                            value={formData.kids}
                            defaultValue={0}
                            min="0"
                            onChange={handleNumberInput}
                        />
                        {/* <span className="small-text-form">5 years & below</span> */}
                    </div>

                    <div className="dropdown-group">
                        <FloatingLabelSelect
                            label="City"
                            name="city"
                            value={location12}
                            onChange={handleLocationChange}
                            options={[
                                { id: "", name: "Select a city" },
                                ...apiData
                            ]}
                            valueKey="name"
                        />

                        <FloatingLabelSelect
                            name="area"
                            label="Area"
                            value={selectedArea?.id || ""}
                            onChange={handleAreaChange}
                            options={[
                                { id: "", name: "Select an area" },
                                ...leadarea
                            ]}
                            valueKey="id"
                        />
                    </div>

                    <div className="dropdown-group">
                        <FloatingLabelSelect
                            label="Package Type"
                            value={packagetitle}
                            onChange={handlePackageChange}
                            options={[
                                { id: "", name: "Select a package" },
                                ...ALCOHOLIC_OPTIONS
                            ]}
                            valueKey="name"
                        />

                        <FloatingLabelSelect
                            name="packagename"
                            label="Package Name"
                            value={packtitle}
                            onChange={handlePackagename}
                            options={[
                                { id: "", name: "Select a package" },
                                ...packagetitlelist
                            ]}
                            valueKey="id"
                        />
                    </div>

                    <div>
                        <FloatingLabelInput
                            type="text"
                            name="instructions"
                            label="Special Instructions"
                            value={formData.instructions}
                            onChange={handleInputChange}
                        />

                        <div className="checkbox">
                            <input
                                type="checkbox"
                                id="agreeCheckbox"
                                name="agree"
                                checked={formData.agree}
                                onChange={handleInputChange}
                            />
                            <span style={{ color: "black" }}>
                                I agree to the{' '}
                                <Link to="/privacy-policy">Privacy Policy</Link> and{' '}
                                <Link to="/term-conditions-policy">Terms & Conditions</Link>.
                            </span>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={buttonDisabled || loading}
                        className={buttonDisabled ? "package-and-table-btn-disabled" : ""}
                    >
                        {loading ? "Submitting..." : (selectedLead ? "Update Lead" : "Reserve Now")}
                    </button>
                </form>

                {/* Success Modal */}
                <Modal open={showPopup} onClose={handleModalClose}>
                    <div className="modal-container">
                        <div className="modal-content">
                            <button className="modal-button" onClick={handleModalClose}>
                                ×
                            </button>
                            <dotlottie-player
                                src="https://lottie.host/6b9fc96a-5c59-464a-ad26-5782e3a54022/EFWiS28KVM.json"
                                background="transparent"
                                speed="1"
                                style={{ height: "300px" }}
                                loop
                                autoplay
                            />
                            <p className="modal-message">Form submitted successfully!</p>
                            <div className="about-us-playstore-image">
                                <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                                    <img src={Googleplay} alt="Google Play Store" />
                                </Link>
                                <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                                    <img src={Applestore} alt="Apple App Store" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
}

export default PackageLaedFormComp;